import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ReactPlayer from 'react-player';
import { ReactComponent as CloseBtn } from '../../../assets/images/graphics/btn-close.svg';
import { calculateSize, formatParagraphs, getImageFilepath } from '../../../models/Utils';
import { setMediaState, setInFullScreenVideo } from '../../../store/reducers/mainReducer';
import { reportEvent } from '../../../store/reducers/gaReducer';
import './Video.scss';
import Spinner from '../../Common/Spinner/Spinner';
import { ADAARIARoles, ADAWidgitRoles, ADALandmarks } from '../../../models/ADA';

const Video = ({ cardData, isInline, size }) => {
  const dispatch = useDispatch();
  const player = useRef(null);
  const activeKey = useSelector(state => state.data.activeSlideKey);
  const [playing, setPlaying] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const updateIntervalMs = 50;
  const [muted, setMuted] = useState(true);
  const [fullscreen, goToFullscreen] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  useEffect(() => {
    clearTimeout(fadeTimeout);

    if (cardData && activeKey === cardData.Key) {
      delayedFade();
      reset();
    } else {
      setMuted(true);
      goToFullscreen(false);
      dispatch(setInFullScreenVideo(false));
      setTimeout(() => {
        setPlaying(false);
      }, 1000);
    }
  }, [activeKey]);

  useEffect(() => {
    dispatch(setMediaState(fullscreen));
  }, [fullscreen]);

  const handleMaximizeClicked = prop => {
    goToFullscreen(true);
    setMuted(false);
    dispatch(setInFullScreenVideo(true));
    dispatch(reportEvent({ category:"VIDEO_PLAYED_DIGITAL_MUSEUM_SLIDE", action: cardData.Header + " - " + cardData.BackgroundVideo.URL}));
  };

  const reset = prop => {
    //player.current.seekTo(0, 'fraction');
    setPlaying(true);
    setMuted(true);
    goToFullscreen(false);
    dispatch(setInFullScreenVideo(false));
  };

  /* Video Events */

  const handleOnEnded = prop => {
    reset();
  };

  var fadeTimeout;
  function delayedFade() {
    fadeTimeout = setTimeout(handleVideoStart, videoTimeout);
  }


  function handleVideoStart() {
    setLoaded(true);
    let iframe = document.querySelector("iframe");
    iframe.setAttribute("tabindex", "-1");
  }

  const handleOnExit = () => {
    goToFullscreen(false);
    dispatch(setInFullScreenVideo(false));
    setMuted(true);
  };

  var dimensions = calculateSize(1920, 1080, size.width, size.height);

  var video = (
    <ReactPlayer
      ref={player}
      className="video"
      url={fullscreen ? cardData.BackgroundVideo.URL : cardData.VideoPreview.BackgroundMedia ? mediaPath + cardData.VideoPreview.BackgroundMedia : cardData.VideoPreview.URL}
      width={fullscreen ? size.width + 'px' : dimensions.width + 'px'}
      height={fullscreen ? size.height + 'px' : dimensions.height + 'px'}
      playing={playing}
      playsinline={fullscreen === false}
      controls={fullscreen}
      loop={fullscreen === false}
      onStart={handleVideoStart}
      muted={muted}
      config={{
        youtube: {
          playerVars: {
            showinfo: 1,
            modestbranding: 1,
          },
        },
      }}
      progressInterval={updateIntervalMs}
      onEnded={handleOnEnded}
      
    />
  );

  var imagePlaceholder = cardData.BackgroundVideo.BackgroundMedia ? (
    <img src={mediaPath + getImageFilepath(cardData.VideoPreview.BackgroundMedia)}
      className="background-image" />
  ) : null;

  var opacityStyle = {
    backgroundColor: cardData.VideoPreview.Overlay ? cardData.VideoPreview.Overlay : 'black',
    opacity: cardData.VideoPreview.Opacity ? cardData.VideoPreview.Opacity : 1,
  };

  const handleOverlayClick = () => {
    setPlaying(!playing);
  }

  var outerClassname = 'story-video ' + (isInline ? "inline" : "");
  var videoClassname = 'videofadein ' + (loaded ? 'loaded' : '');

  //console.log("[Digital Museum - Video]", cardData)

  return (
    <div className={outerClassname} role={ADALandmarks.Main}>
      {fullscreen === false ? (
        <>
          <div className="video-placeholder" style={opacityStyle}>
            <div className={videoClassname} role="img" alt={cardData.BackgroundVideo.AltText}>
              {!cardData.VideoPreview.BackgroundMedia || cardData.VideoPreview.BackgroundMedia.length === 0 ?
                video
              : (cardData.VideoPreview.BackgroundMedia.split(".").pop() === "mp4" ? video : imagePlaceholder)}
            </div>
          </div>
          <div className="text-holder" onKeyDown={handleMaximizeClicked} onClick={handleMaximizeClicked}>
            <div className="header" role={ADAARIARoles.Heading} >{cardData.Header}</div>
            <div className="ada-hidden">:</div>
            <div className="body">{formatParagraphs(cardData.Body)}</div>
            <div className="video-play-button-ada"   tabIndex={!menuOpened ? 0 : -1} aria-label="Play" role={ADAWidgitRoles.Button}>
                <div className="video-play-button" />
            </div>
          </div>
          <div className="video-touch-blocker" onClick={handleMaximizeClicked} onKeyDown={handleMaximizeClicked}/>
        </>
      ) : null}
      {fullscreen ? (
        <div className="video-fullscreen">
          {video}
          <div className="video-touch-overlay" onClick={handleOverlayClick}/>
          <CloseBtn className="exit-button"  role="button" aria-label="close" onClick={handleOnExit} tabIndex={!menuOpened ? 0 : -1} alt={"Close Video"} role={ADAWidgitRoles.Button} />
        </div>
      ) : null}
    </div>
  );
};

export default Video;
